import { useQueryClient, UseMutationResult } from '@tanstack/react-query'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'
import { ClientWithSecret } from '../models'
import { createClient } from '../api/client.api'
import { clientQueryKey } from './use-client'

/**
 * Creates an API access client for a user and invalidates the cached client on success.
 */
export const useCreateClient = (userId: number | undefined, onSuccess?: () => void): UseMutationResult<ClientWithSecret | null, Error, void> => {
  const authFetch = useAuthFetchWithResponse()
  const queryClient = useQueryClient()

  return usePortalMutation<ClientWithSecret, Error, void>({
    mutationFn: () => createClient(userId, authFetch),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: clientQueryKey(userId) })
      onSuccess?.()
    },
  })
}
